import { InjectionKey } from 'vue';
import { RepositoryFactory, Repositories } from '@/repositories/RepositoryFactory';

const CustomerRepository = RepositoryFactory.get('customer') as Repositories['customer'];

export const useCustomer = () => {
  /**
   * 顧客情報
   */
  const get = async () => {
    return await CustomerRepository.get();
  };

  return {
    get,
  };
};

type CustomerType = ReturnType<typeof useCustomer>;
export const CustomerKey: InjectionKey<CustomerType> = Symbol('Customer');
